export function validateEmail(email:string) {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}